/* eslint-disable no-unused-vars */
import { useState } from 'react'
import cn from 'classnames'
// Components
import Input from '../newInput/Input'
import styles from './RadioSelector.module.scss'
import OutsideClickHandler from 'react-outside-click-handler'

type RadioSelectorProps = {
  options?: any[]
  value: any
  placeholder: string
  onChange: (value: any) => void
  disabled?: boolean
  theme?: string | string[]
  showError?: boolean
  errorMessage?: string
  modalPlaceholder?: string
  clearSelection?: () => void
}

export default function Select({
  options: _options = [],
  value,
  placeholder,
  onChange,
  disabled,
  theme,
  showError,
  errorMessage,
  modalPlaceholder,
  clearSelection,
}: RadioSelectorProps) {
  // Handles themes
  const classes = { [styles.option]: true }
  if (typeof theme === 'string') theme = [theme]
  theme?.forEach((t) => {
    classes[styles[t]] = typeof t !== 'undefined'
  })
  const hasRadio =
    classes[styles['radio-rounded']] || classes[styles['radio-square']]

  const [showOptions, setShowOptions] = useState(false) // Creatable
  const [showModal, setShowModal] = useState(false)
  const [input, setInput] = useState('')

  const options = _options

  return (
    <div
      className={cn({
        [styles.container]: true,
        [styles.hasErrorMessage]: !!errorMessage,
      })}
    >
      <OutsideClickHandler
        onOutsideClick={() => {
          if (showOptions) setShowOptions(false)
        }}
      >
        <div
          className={cn({
            [styles.select]: true,
            [styles.active]: value.length !== 0,
            [styles.showError]: showError,
          })}
          onClick={() => setShowOptions((c) => !c)}
        >
          <div className={styles.label}>{value?.label || placeholder}</div>

          {!showOptions && value.length !== 0 ? (
            <div
              className={styles.icon}
              style={{ backgroundImage: 'url(/form_modal/deselect.svg)' }}
              onClick={() => clearSelection()}
            />
          ) : (
            <div
              className={styles.icon}
              style={{
                backgroundImage: showOptions
                  ? 'url(/search/arrow-top-black.svg)'
                  : 'url(/search/arrow-down-black.svg)',
              }}
            />
          )}
        </div>

        {showOptions && (
          <div className={styles.optionsContainer}>
            <div className={styles.arrow} />

            <div
              className={cn({
                [styles.options]: true,
              })}
            >
              {options.length &&
                options.map((o) => (
                  <div
                    key={o.value}
                    className={cn({
                      ...classes,
                      [styles.current]: o?.value === value?.value,
                      [styles.disabled]: disabled,
                    })}
                    onClick={() => {
                      if (!disabled) {
                        onChange(o)
                        setShowOptions(false)
                      }
                    }}
                  >
                    {/* For 'radio-rounded' and 'radio-square' themes */}
                    {hasRadio && <div className={styles.checkbox} />}

                    <div className={styles.label}>{o.label}</div>
                  </div>
                ))}
            </div>
          </div>
        )}

        {showModal && (
          <div className={styles.background}>
            <div className={styles.modal}>
              <div
                className={styles.close}
                onClick={() => setShowModal(false)}
              />

              <Input
                value={input}
                placeholder={modalPlaceholder}
                onChange={(e) => setInput(e.target.value)}
              />
            </div>
          </div>
        )}

        {showError && !!errorMessage && (
          <div className={styles.error}>
            <div className={styles.icon} />
            <div className={styles.message}>{errorMessage}</div>
          </div>
        )}
      </OutsideClickHandler>
    </div>
  )
}
